import { render, staticRenderFns } from "./MobileStudentLogin.vue?vue&type=template&id=6b6f5339&scoped=true&"
import script from "./MobileStudentLogin.vue?vue&type=script&lang=js&"
export * from "./MobileStudentLogin.vue?vue&type=script&lang=js&"
import style0 from "./MobileStudentLogin.vue?vue&type=style&index=0&id=6b6f5339&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6f5339",
  null
  
)

export default component.exports